export default "__VITE_ASSET__Bg4HFdTN__"